<template>
  <div class="pad30">
    <h2 class="f18 fb normal gray_2">促销管理--优惠活动列表</h2>
    <div class="box20"></div>
    <template>
      <div class="status-container">
        <el-tabs v-model="searchForm.activeState" @tab-click="activeStateChange">
          <el-tab-pane label="全部活动" name="ALL"></el-tab-pane>
          <el-tab-pane label="未开始" name="NOT_START"></el-tab-pane>
          <el-tab-pane label="进行中" name="HAVE_IN_HAND"></el-tab-pane>
          <el-tab-pane label="已结束" name="ALREADY_OVER"></el-tab-pane>
        </el-tabs>
      </div>
    </template>
    <div class="flex flex-wrap flex1 items-center mar20-b">
      <div>
        <span>活动名称：</span>
        <el-input class="w210 mar20_r" placeholder="请输入活动名称" v-model.trim="searchForm.promotionName"></el-input>
      </div>
      <div>
        <span>活动类型：</span>
        <el-select class="w210 mar20_r" v-model="searchForm.promotionType" placeholder="请选择">
          <el-option v-for="item in promotionTypeList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="getList">查询</el-button>

      <el-button type="primary" class="mar-20-l" @click="addPromotionType">新增促销活动</el-button>
    </div>
    <el-table :data="list" @selection-change="promotionSelect" row-key="id" style="width: 100%" height="450">
      <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
      <el-table-column show-overflow-tooltip prop="promotionName" label="活动名称" />
      <el-table-column prop="promotionType" label="活动类型">
        <template slot-scope="scope">
          <span v-if="scope.row.promotionType === 'DIRECT_SELLING'">直降</span>
          <span v-if="scope.row.promotionType === 'DISCOUNT'">折扣</span>
          <span v-if="scope.row.promotionType === 'BUY_GIFTS'">买赠</span>
          <span v-if="scope.row.promotionType === 'GROUP_PURCHASE'">集采</span>
        </template>
      </el-table-column>
      <el-table-column prop="cartNum" label="货品数" />
      <el-table-column prop="startDate" label="开始时间" />
      <el-table-column prop="endDate" label="结束时间" />
      <el-table-column prop="activeState" label="活动状态">
        <template slot-scope="scope">
          <span v-if="scope.row.activeState === 'NOT_START'">未开始</span>
          <span v-if="scope.row.activeState === 'HAVE_IN_HAND'">进行中</span>
          <span v-if="scope.row.activeState === 'ALREADY_OVER'">已结束</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="primary" v-if="scope.row.activeState!== 'ALREADY_OVER'" @click="updatePromotion(scope.row.id)">编辑</el-button>
          <el-button type="primary" v-if="scope.row.activeState!== 'HAVE_IN_HAND'" class="mar15-l" @click="deletePromotion(scope.row.id)">删除</el-button>
          <el-button type="primary" v-if="scope.row.activeState=== 'HAVE_IN_HAND'" class="mar15-l" @click="stopPromotion(scope.row)">结束</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex items-center mar20-t">
      <el-button type="primary" @click="updatePromotionList">结束活动</el-button>
      <el-button type="primary" class="mar-20-l" @click="deletePromotionList">删除活动</el-button>
      <div class="gray9 flex-auto mar-20-l">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
      <el-pagination
        layout="prev, pager, next, sizes, jumper"
        background
        hide-on-single-page
        :page-size.sync="pageSize"
        :page-count="totalPage"
        :current-page.sync="pageNum"
        :page-sizes="[6, 10, 20]"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      env: process.env,
      searchForm: {
        promotionName: "",
        promotionType: "",
        activeState: "ALL",
      },

      list: [],
      promotionTypeList: [
        {
          id: "DIRECT_SELLING",
          name: "直降",
        },
        {
          id: "DISCOUNT",
          name: "折扣",
        },
        {
          id: "BUY_GIFTS",
          name: "买赠",
        },
        {
          id: "GROUP_PURCHASE",
          name: "集采",
        },
      ],

      pageSize: 10,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,
      multipleSelection: [],
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getList();
  },
  methods: {
    activeStateChange(tab) {
      this.searchForm.activeState = tab.name;
      this.getList();
    },
    getList() {
      let type = "";
      const { pageNum, searchForm } = this;
      const { promotionName, promotionType, activeState } = searchForm;
      type = activeState;
      if (activeState === "ALL") {
        type = "";
      }
      this.$store
        .dispatch("promotion/promotion/getPromotionInfoList", {
          pageNum: pageNum,
          promotionName: promotionName,
          promotionType: promotionType,
          activeState: type,
        })
        .then((res) => {
          const { totalCount = 0, promotionList = [], totalPage = 0 } = res;
          this.list = promotionList;
          this.pageTotal = totalCount;
          this.totalPage = totalPage;
        });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    promotionSelect(val) {
      this.multipleSelection = val || [];
      console.log(this.multipleSelection);
    },
    addPromotionType() {
      window.location.href = `${process.env.VUE_APP_APP}mj/promotion/addPromotion.do`;
    },
    updatePromotion(id) {
      window.location.href = `${process.env.VUE_APP_APP}mj/promotion/updatePromotion.do?id=` + id;
    },

    deletePromotion(id) {
      this.$confirm("是否删除活动?", "提示").then(() => {
        this.$store.dispatch("promotion/promotion/deletePromotion", { id: id }).then((data) => {
          if (data) {
            this.$message.success("删除成功");
            this.pageNum = 1;
            this.getList();
          }
        });
      });
    },

    stopPromotion(row) {
      const idList = [row.id];
      this.$confirm("是否结束当前正在进行中的活动?", "提示").then(() => {
        this.$store
          .dispatch("promotion/promotion/updateActive", {
            idList: idList.join(","),
            shopId: row.shopId,
          })
          .then((data) => {
            if (data) {
              this.$message.success("活动已结束");
              this.pageNum = 1;
              this.getList();
            }
          });
      });
    },

    deletePromotionList() {
      if (this.multipleSelection.length == 0) {
        this.$message.info("请选择促销活动");
        return;
      }
      const idList = [];
      this.multipleSelection.forEach(function (item) {
        idList.push(item.id);
      });
      this.$confirm("是否删除活动?", "提示").then(() => {
        this.$store
          .dispatch("promotion/promotion/deletePromotionList", {
            idList: idList.join(","),
            shopId: this.multipleSelection[0].shopId,
          })
          .then((data) => {
            if (data) {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getList();
            }
          });
      });
    },
    updatePromotionList() {
      if (this.multipleSelection.length == 0) {
        this.$message.info("请选择促销活动");
        return;
      }
      let isUpdate = true;
      const idList = [];
      this.multipleSelection.forEach(function (item) {
        if (item.activeState === "ALREADY_OVER") {
          isUpdate = false;
        }
        idList.push(item.id);
      });
      if (!isUpdate) {
        this.$message.info("存在已结束的活动，请选择未结束的活动");
        return;
      }
      this.$confirm("是否结束活动?", "提示").then(() => {
        this.$store
          .dispatch("promotion/promotion/updateActive", {
            idList: idList.join(","),
            shopId: this.multipleSelection[0].shopId,
          })
          .then((data) => {
            if (data) {
              this.$message.success("活动已结束");
              this.pageNum = 1;
              this.getList();
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index.scss";
</style>
<style>
.el-select-dropdown__item.selected {
  color: #0095f1;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0095f1;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0095f1;
  border-color: #0095f1;
}
.el-checkbox__input.is-focus .el-checkbox__inner,
.el-checkbox__inner:hover {
  border-color: #0095f1;
}
.el-input-group__prepend .el-select {
  width: 75px;
}
.el-tabs__item.is-active {
  color: #0095f1;
}
.el-tabs__item:hover {
  color: #0095f1;
}
.el-tabs__active-bar {
  background-color: #0095f1;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0095f1;
  border-color: #0095f1;
}
.el-button--primary {
  color: #ffffff;
  background-color: #409eff;
  border-color: #409eff;
}
.el-button:hover,
.el-button:focus {
  color: #ffffff;
  border-color: #409eff;
  background-color: #409eff;
}
</style>
